<template>
<div>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-user-circle-o"></i> {{ $t('user.profile') }}
    </div>
    <div class="card-body">
      <errorMessage v-bind:message="error"></errorMessage>

      <form>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="firtNameInput">{{ $t('user.form.name') }}</label>
          <input disabled v-model.trim="user.firstName" v-validate="'required'" 
            name="firstName" type="text" class="form-control" id="firtNameInput">
        </div>
        <div class="form-group col-md-6">
          <label for="lastNameInput">{{ $t('user.form.surname') }}</label>
          <input disabled v-model.trim="user.lastName" v-validate="'required'" 
            name="lastName" type="text" class="form-control" id="lastNameInput">
        </div>
      </div>

      <div class="form-group">
        <label for="emailInput">{{ $t('user.form.emailOrUsername') }}</label>
        <input disabled v-model.trim="user.emailAddress" v-validate="'required|email'"
          name="emailAddress" type="email" class="form-control" id="emailInput">
      </div>

      <div class="form-group">
        <label for="phoneInput">{{ $t('user.form.phone') }}</label>
        <input disabled v-model.trim="user.phoneNumber" type="text" class="form-control" id="phoneInput">
      </div>
      
       <div class="form-group">
        <label for="roleInput">{{ $t('user.form.roles') }}</label>
        <ul>
          <li v-for="role in user.roleNames">{{role.name}}</li>
        </ul>
      </div>
      </form>
    </div>
  </div>
  <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-key"></i> {{ $t('user.changePasswordTitle') }}
      </div>
      <div class="card-body">        

        <errorMessage v-bind:message="error"></errorMessage>

        <password-input v-bind:action="changePasswordAction"></password-input>
        
      </div>
    </div>
</div>
</template>

<script>
import {UserServiceClient, CreateUserDto, RoleServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import PasswordInput from '../../shared/components/PasswordInput.vue'

export default {
  name: 'profile',
  mixins: [CrudMixin],
  data() {
    let self = this
    let changePasswordAction = function(clean) {
      let userService = ServiceFactory.create(UserServiceClient)
      userService
        .changePassword({
          userId: this.$store.state.currentUser.id,
          password: this.password,
        })
        .then(res => {
          clean()
          this.$swal(this.$i18n.t('success'), '', 'success')
        })
        .catch(err => {
          self.processError(err, self)
        })
    }

    return {
      ready: false,
      edit: false,
      error: '',
      user: this.$store.state.currentUser,
      changePasswordAction: changePasswordAction,
    }
  },
  created: function() {
    this.edit = this.$route.params.id != undefined
    this.fetchData()
  },
  mounted: function() {},
  methods: {
    editUser: function() {
      this.$validator.validateAll().then(result => {
        if (result && this.ready) {
          let userService = ServiceFactory.create(UserServiceClient)

          userService
            .update(this.cleanFields(this.user))
            .then(res => {
              this.$swal(this.$i18n.t('success'), '', 'success')
              this.$router.push({path: '/users'})
            })
            .catch(err => {
              this.processError(err, this)
            })
        }
      })
    },
    fetchData: function() {},
  },
  components: {
    errorMessage: ErrorMessage,
    'password-input': PasswordInput,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/users/Profile.vue